class VwHbsArsivhareketDTO {
    id: number = null;
    fkArsivtanimId?: number = null;
    arsivPerTeslimEden?: number = null;
    arsivPerTeslimAlan?: number = null;
    teslimAlan?: number = null;
    teslimAlmaTarihi?: string = null;
    teslimEden?: number = null;
    teslimEdilmeTarihi?: string = null;
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    adi?: string = "";
    hastaAdi?: string = "";
    hastaSoyadi?: string = "";
    yerlesimyeradi?: string = "";
    dokutemelozellikadi?: string = "";
    alinmasekiladi?: string = "";
    materyaladi?: string = "";
    rednedenadi?: string = "";
    kimlikId?: number = null;
    muracaatId?: number = null;
    protokolNo?: number = null;
    protokolOnek?: string = "";
    protokolYil?: number = null;
    searchText?: string = "";
    arsivTeslimEdenAd?: string = "";
    arsivTeslimAlanAd?: string = "";
    teslimAlanAd?: string = "";
    teslimEdenAd?: string = "";
};
export default VwHbsArsivhareketDTO;